export default __webpack_public_path__ + "static/fundamentals-2-fe4f35efb500c5296646f6ec87a66ac2.jpg";